var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chooser"},[_c('h2',{staticClass:"chooser-title"},[_vm._v("See data for your area:")]),_c('PostcodePicker',{attrs:{"usePostcodes":true,"useCouncils":true},on:{"submit":_vm.postcodeSubmitHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }